"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalNetworkRpc = exports.SERVICE_ID = void 0;
const dht_1 = require("@streamr/dht");
const proto_rpc_1 = require("@streamr/proto-rpc");
exports.SERVICE_ID = 'external-network-service';
class ExternalNetworkRpc {
    rpcCommunicator;
    constructor(transport) {
        this.rpcCommunicator = new dht_1.ListeningRpcCommunicator(exports.SERVICE_ID, transport);
    }
    registerRpcMethod(request, response, name, fn) {
        this.rpcCommunicator.registerRpcMethod(request, response, name, fn);
    }
    createRpcClient(clientClass) {
        return (0, proto_rpc_1.toProtoRpcClient)(new clientClass(this.rpcCommunicator.getRpcClientTransport()));
    }
    destroy() {
        this.rpcCommunicator.destroy();
    }
}
exports.ExternalNetworkRpc = ExternalNetworkRpc;
//# sourceMappingURL=ExternalNetworkRpc.js.map